import React from 'react';
import ReactDOM from 'react-dom/client';

import 'monday-ui-react-core/dist/main.css';
import App from './App';
import { AppContextProvider } from './AppContext';
import { initializeClarity } from './utils/clarity.utils';
import './i18n';
import '@vibe/core/tokens';

import { pdfjs } from 'react-pdf/dist/esm/entry.vite';
// Self-host the worker from node_modules instead of unpkg CDN
// This avoids network errors on mobile (especially Firefox Android)
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

// Initialize Microsoft Clarity for analytics and session tracking
initializeClarity();

//@ts-ignore

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </React.StrictMode>,
);
